import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { comfortLightDare } from "../comfortLightDare/comfortLightDareAPI";

const initialState = {
    status: "idle",
    NewQuestion:'',
    NewQuestionTimer: '',
    DrinkQuestion: '',
    Attributes: [],
    Accessories:[],
    UsedQuestionsId:[],
    LastCard: false,
}

export const comfortLightDareAsync = createAsyncThunk(
    "/comfortlightdare",
    async ({gender, player}, {getState, rejectWithValue }) => {
        try {
            const state = getState()
            const usedid = state.comfortLightDare.UsedQuestionsId
            const sessionid = state.gameStatus.sessions['comfort'].sessionId
            const selectedaccessories = state.comfortLightDare.Accessories
        
            
        
            const response = await comfortLightDare(gender, player, usedid, selectedaccessories, sessionid);
            return response
        } catch (error) {
        console.error("Error in comfortLightDareAsync:", error); // 👀 This should appear now
        return rejectWithValue(error.response
            ? { data: error.response.data, status: error.response.status }
            : { data: { error: "Unknown error" }, status: 500 })
    }
    }
)

export const comfortLightDareSlice = createSlice({
    name: "comfortlightdare",
    initialState,
    reducers: {
        setAccessories: (state, action) =>{
            state.Accessories = action.payload

        },
        resetState:(state) =>{
            state.status ="idle"
            state.NewQuestion = ''
            state.NewQuestionTimer = ''
            state.DrinkQuestion = ''
            state.Attributes = []
            state.Accessories = []
            state.UsedQuestionsId =[]
            state.LastCard = false;
        },
    },
    extraReducers:(builder) => {
        builder
            .addCase(comfortLightDareAsync.pending, (state) => {
                state.status = 'fetching';
            })
            .addCase(comfortLightDareAsync.fulfilled, (state, action)=>{
                state.status ="fulfilled";
                state.NewQuestion = action.payload.question
                state.NewQuestionTimer = action.payload.timer
                state.DrinkQuestion = action.payload.drink
                state.UsedQuestionsId = [...state.UsedQuestionsId,action.payload.id]
                state.Attributes = [action.payload.attributes]
                state.LastCard = action.payload.last_card || false;
            })}})

export const selectComfortLightDare = (state) => state.comfortLightDare
export const { setAccessories, resetState } = comfortLightDareSlice.actions;
export default comfortLightDareSlice.reducer